import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M252.309-400v-160h-80q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v375.382q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846h615.382q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-375.382q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H400v-59.999h387.691q30.308 0 51.308 21t21 51.308v375.382q0 30.308-21 51.308t-51.308 21H172.309q-30.308 0-51.308-21t-21-51.308v-375.382q0-30.308 21-51.308t51.308-21h80v-240h289.997v152.308H312.307V-400h-59.998zM160-560v160-160 400-400z"
      ></path>
    </svg>
  );
}

export default Icon;
